<div class="position-fixed w-100 header-wrapper">
  <app-accessibility-nav></app-accessibility-nav>
  <app-navbar></app-navbar>
</div>
<div
  class="min-vh-100 py-5 container d-flex flex-column justify-content-center align-items-center gap-2"
>
  <img
    src="images/no_data_found.svg"
    alt="No data found"
    class="mt-5 rounded not-found-img"
  />
  <span class="text-primary text-sm">Oops...</span>
  <span class="text-sm">
    The requested resource is unavailable.Please try again later or return to
    the
    <a class="text-primary" [routerLink]="['/', routes.home]"> Homepage </a>.
  </span>
</div>
<app-footer></app-footer>
